if (!customElements.get('card-message')) {
  customElements.define(
    'card-message',
    class CardMessage extends HTMLElement {
      connectedCallback() {
        this.input = this.querySelector('textarea');
        this.errorEl = this.querySelector('.card-message__error');
        if (!this.input) return;

        this.input.addEventListener('input', () => this.refresh(false));
        this.input.addEventListener('change', () => this.save());
        this.input.addEventListener('blur', () => this.save());

        this.bindForm();
        this.refresh(false);
      }

      isFilled() {
        return this.input.value.trim().length > 0;
      }

      bindForm() {
        const form = document.getElementById(this.dataset.formId);
        if (!form || form.dataset.cardMessageBound === 'true') return;
        form.dataset.cardMessageBound = 'true';

        form.addEventListener('submit', (event) => {
          if (!event.submitter || event.submitter.name !== 'checkout') return;
          if (this.isFilled()) return;
          event.preventDefault();
          this.refresh(true);
          this.input.focus();
          this.input.scrollIntoView({ block: 'center', behavior: 'smooth' });
        });
      }

      refresh(showError) {
        const valid = this.isFilled();
        this.input.setAttribute('aria-invalid', valid ? 'false' : 'true');
        if (this.errorEl) this.errorEl.toggleAttribute('hidden', valid || !showError);

        document.querySelectorAll('.cart__checkout-button').forEach((button) => {
          button.disabled = !valid;
        });

        // Keep the drawer and cart page in sync if both are on the page.
        document.querySelectorAll('card-message textarea').forEach((el) => {
          if (el !== this.input) el.value = this.input.value;
        });
      }

      save() {
        this.refresh(false);
        return fetch(`${routes.cart_update_url}`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ attributes: { 'Card Message': this.input.value.trim() } }),
        }).catch((e) => console.error(e));
      }
    }
  );
}